"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Coachmark_styles_1 = require("./Coachmark.styles");
var Coachmark_base_1 = require("./Coachmark.base");
exports.Coachmark = Utilities_1.styled(Coachmark_base_1.CoachmarkBase, Coachmark_styles_1.getStyles, undefined, {
    scope: 'Coachmark'
});
//# sourceMappingURL=Coachmark.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/Coachmark/Coachmark.js
// module id = 784
// module chunks = 0